import React from 'react';
import { Link } from 'react-router-dom';
import { LockIcon } from 'lucide-react';
import { Logo } from '../ui/Logo';
interface PortalHeaderProps {
  right?: React.ReactNode;
  center?: React.ReactNode;
  maxWidth?: string;
}
export function PortalHeader({
  right,
  center,
  maxWidth = 'max-w-6xl'
}: PortalHeaderProps) {
  return <header className="sticky top-0 z-30 border-b border-ink-200/70 bg-canvas/85 backdrop-blur-md" data-id="element-556" data-mp="3jct0n64xr7vo">
      <div className={`mx-auto flex h-16 items-center gap-4 px-4 md:px-8 ${maxWidth}`} data-id="element-557" data-mp="3fdbt875y80nv">
        <Link to="/" className="flex items-center gap-3 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pulse-500" aria-label="Pulse home" data-id="element-558" data-mp="3abuwmnuhz0d3">
          <Logo data-id="element-559" data-mp="30ezvdx6ualv4" />
        </Link>
        <span className="hidden items-center gap-1.5 rounded-full bg-white px-2.5 py-1 text-xs font-medium text-ink-500 ring-1 ring-ink-200 lg:inline-flex" data-id="element-560" data-mp="30frqz80fsjle">
          <LockIcon className="h-3 w-3 text-positive-500" aria-hidden data-id="element-561" data-mp="ynd5y02liz0r" />
          Secure session
        </span>
        <div className="flex min-w-0 flex-1 justify-center" data-id="element-562" data-mp="1zw1j4h2o2mfx">{center}</div>
        <div className="flex items-center gap-3" data-id="element-563" data-mp="24ve5z1tjftii">{right}</div>
      </div>
    </header>;
}